module.exports = __webpack_public_path__ + "img/PSSS-J-3.13dd7ca2.svg";